import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { authAPI as api } from "../../../api";

const CreatePassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { id } = useParams();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      alert("Les mots de passe ne correspondent pas");
      return;
    }

    try {
      await api.post(`/set-password/${id}`, { password });
      alert("Mot de passe créé avec succès");
      navigate("/login");
    } catch (error) {
      console.error("Erreur:", error);
      alert("Erreur lors de la création du mot de passe");
    }
  };

  return (
    <div className="create-password-container">
      <h2>Création de votre mot de passe</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Nouveau mot de passe</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Confirmer le mot de passe</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit">Créer le mot de passe</button>
      </form>
    </div>
  );
};

export default CreatePassword;
